var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.cleanOrderID && _vm.order)?_c('OrderInvoice',{attrs:{"order":_vm.order,"customer":_vm.customer}}):_c('p',[_vm._v("Invalid order number")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }